import React from 'react';
import { useField } from 'formik';
import { Input, Upload, message,Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

export const FormikInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <div style={{ marginBottom: '16px' }}>
      {label && <label>{label}</label>}
      <Input {...field} {...props} />
      {meta.touched && meta.error ? (
        <div style={{textAlign:"left", color:"red"}} className="error">{meta.error}</div>
      ) : null}
    </div>
  );
};

export const FormikPassword = ({ label, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <div style={{ marginBottom: '16px' }}>
      {label && <label>{label}</label>}
      <Input.Password {...field} {...props} />
      {meta.touched && meta.error ? (
        <div style={{textAlign:"left", color:"red"}} className="error">{meta.error}</div>
      ) : null}
    </div>
  );
};

export const FormikUpload = ({ label, setFieldValue, ...props }) => {
  const [field, meta] = useField(props.name);

  const handleChange = (info) => {
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
    setFieldValue(props.name, info.fileList);
  };

  return (
    <div style={{ marginBottom: '16px', display:"flex", alignItems:"center", justifyContent:"space-between" }}>
      {label && <label>{label}</label>}
      {/* <Upload
        {...field}
        {...props}
        onChange={handleChange}
        beforeUpload={() => false} 
      >
        <Button icon={<UploadOutlined />}>Add Photo</Button>
      </Upload> */}
      {meta.touched && meta.error ? (
        <div style={{textAlign:"left", color:"red"}} className="error">{meta.error}</div>
      ) : null}
    </div>
  );
};
